"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DrawerTabContext_1 = require("./DrawerTabContext");
const DrawerTabContent = ({ children, tabId }) => {
    const { selectedTabId } = DrawerTabContext_1.useDrawerTabContext();
    return selectedTabId === tabId ? children : null;
};
exports.default = DrawerTabContent;
